import AppContainer from 'components/App/AppContainer'
import AppData from 'components/App/AppData'

export default {
  Container: AppContainer,
  Data: AppData,
}
